import React, { useState, useEffect } from 'react';

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

var tenants = [
    {
        key: 'derbund',
        name: 'der Bund',
        feedId: 1,
        lang: 'de',
    },
    {
        key: 'tagesanzeiger',
        name: 'Tages-Anzeiger',
        feedId: 2,
        lang: 'de',
    },
    {
        key: 'bernerzeitung',
        name: 'Berner Zeitung',
        feedId: 3,
        lang: 'de',
    },
    {
        key: 'bazonline',
        name: 'Basler Zeitung',
        feedId: 5,
        lang: 'de',
    },
    {
        key: 'berneroberlaender',
        name: 'Berner Oberländer',
        feedId: 8,
        lang: 'de',
    },
    {
        key: 'thunertagblatt',
        name: 'Thuner Tagblatt',
        feedId: 9,
        lang: 'de',
    },
    {
        key: 'langenthalertagblatt',
        name: 'Langenthaler Tagblatt',
        feedId: 10,
        lang: 'de',
    },
    {
        key: 'zsz',
        name: 'Zürichsee-Zeitung',
        feedId: 11,
        lang: 'de',
    },
    {
        key: 'landbote',
        name: 'Der Landbote',
        feedId: 12,
        lang: 'de',
    },
    {
        key: 'zuonline',
        name: 'Zürcher Unterländer',
        feedId: 13,
        lang: 'de',
    },
    {
        key: 'tdg',
        name: 'Tribune de Genève',
        feedId: 14,
        lang: 'fr',
    },
    {
        key: '24heures',
        name: '24 heures',
        feedId: 15,
        lang: 'fr',
    },
    {
        key: 'bilan',
        name: 'Bilan',
        feedId: 17,
        lang: 'fr',
    },
];

var DevTools = function (_a) {
    var _b;
    var MicroFrontend = _a.MicroFrontend;
    var _c = useState(false), showDevTools = _c[0], setShowDevTools = _c[1];
    var _d = useState(false), isDarkmode = _d[0], setIsDarkmode = _d[1];
    var _e = useState(((_b = navigator === null || navigator === void 0 ? void 0 : navigator.language) === null || _b === void 0 ? void 0 : _b.includes('fr')) ? '24heures' : 'tagesanzeiger'), tenantKey = _e[0], setTenantKey = _e[1];
    function darkmodeClicked() {
        var newVal = !isDarkmode;
        setIsDarkmode(newVal);
        localStorage.setItem('isDarkmode', JSON.stringify(newVal));
    }
    function tenantClicked(tenantKey) {
        setTenantKey(tenantKey);
        localStorage.setItem('tenantKey', JSON.stringify(tenantKey));
    }
    useEffect(function () {
        if (localStorage.getItem('isDarkmode')) {
            setIsDarkmode(JSON.parse(localStorage.getItem('isDarkmode')));
        }
        if (localStorage.getItem('tenantKey')) {
            setTenantKey(JSON.parse(localStorage.getItem('tenantKey')));
        }
    }, []);
    useEffect(function () {
        if (isDarkmode) {
            console.log(document.body);
            document.body.style.backgroundColor = '#121212';
        }
        else {
            document.body.style.backgroundColor = '#fff';
        }
    }, [isDarkmode]);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { style: toolsContainerStyle },
            React.createElement("b", { style: __assign(__assign({}, titleStyle), { opacity: showDevTools ? 1 : 0.5 }), id: 'dev-tools-title', onClick: function () { return setShowDevTools(!showDevTools); } },
                "\uD83D\uDEE0\uFE0F ",
                showDevTools ? 'Hide' : 'Show',
                " Devtools"),
            React.createElement(React.Fragment, null, showDevTools && (React.createElement("div", null,
                React.createElement("div", { className: 'tool', style: toolStyle },
                    React.createElement("span", null, "Darkmode:"),
                    React.createElement("input", { type: 'button', value: isDarkmode ? 'off' : 'on', onClick: function () { return darkmodeClicked(); } })),
                React.createElement("div", { className: 'tool', style: toolStyle },
                    React.createElement("span", null, "Tenant:"),
                    React.createElement("select", { value: tenantKey, onChange: function (event) {
                            return tenantClicked(event.target.value);
                        } }, tenants.map(function (tenant) { return (React.createElement("option", { key: tenant.key, value: tenant.key }, tenant.name)); }))),
                typeof process !== 'undefined' && process.env.REACT_APP_DEPLOY_PATH && (React.createElement("a", { className: 'linkToJS', onClick: function (e) {
                        e.preventDefault();
                        navigator.clipboard.writeText(process.env.REACT_APP_DEPLOY_PATH + '/static/js/main.js');
                    }, href: process.env.REACT_APP_DEPLOY_PATH + '/static/js/main.js' }, "Copy URL to JS \uD83D\uDD17")))))),
        React.createElement(MicroFrontend, { colorMode: isDarkmode ? 'dark' : 'light', tenant: tenants.find(function (ten) { return ten.key === tenantKey; }) })));
};
var titleStyle = {
    display: 'inline-flex',
    color: 'var(--text-color)',
    userSelect: 'none',
    cursor: 'pointer',
    justifyContent: 'flex-end',
};
var toolsContainerStyle = {
    transition: 'all 0.3s ease',
    color: 'var(--text-color)',
    fontFamily: 'Arial, Helvetica, sans-serif',
    fontSize: '12px',
    top: 0,
    right: 0,
    position: 'fixed',
    padding: '0.75em 1em',
    display: 'grid',
    gridGap: '0.5em',
    zIndex: 999,
    backgroundColor: 'rgba(242, 243, 244, 0.3)',
    backdropFilter: 'blur(7px)',
    WebkitBackdropFilter: 'blur(7px)',
    border: 'solid 1px rgba(203, 205, 209, 0.5)',
    maxHeight: '100px',
    borderRadius: '5px',
};
var toolStyle = {
    display: 'flex',
    margin: '0 0 0.5em 0',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: '2em',
};

export { DevTools, tenants };
//# sourceMappingURL=index.m.js.map
